import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Combobox } from '@salesforce/design-system-react';
import { default as timeZoneIds } from '../../../i18n/timeZones';

import './Timezone.scss';

const DEFAULT_TIME_ZONE_ID = 'UTC';

class Timezone extends Component {
  choiceFor(assetType, newEntity = false) {
    const { formatMessage } = this.props.intl;
    const label = newEntity
      ? formatMessage(
          { id: 'components.ecs.assetWizard.newItem' },
          { type: assetType }
        )
      : assetType;
    return {
      id: assetType,
      label,
      value: assetType
    };
  }

  timeZones() {
    return timeZoneIds.map(t => this.timeZoneFor(t));
  }

  timeZoneFor(id) {
    const { formatMessage } = this.props.intl;
    return {
      id,
      label: formatMessage({ id: `timeZones.${id}` })
    };
  }

  currentSelection() {
    const timezone = this.props.timezoneChanged
      ? this.props.tempTimezone
        ? this.props.tempTimezone
        : this.props.timezone
      : this.props.timezone
      ? this.props.timezone
      : DEFAULT_TIME_ZONE_ID;
    return timezone ? [this.selectionFor(timezone)] : [];
  }

  selectionFor(timezone) {
    const { formatMessage } = this.props.intl;
    return {
      id: timezone,
      label: formatMessage({ id: `timeZones.${timezone}` })
    };
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="timezone">
        <Combobox
          classNameContainer="timezone-combobox"
          labels={{
            label: formatMessage({
              id: 'components.ecs.rules.timezone.label'
            })
          }}
          readonly
          options={this.timeZones()}
          selection={this.currentSelection()}
          events={{
            onSelect: (evt, data) => {
              if (!data.selection[0]) {
                return null;
              }

              this.props.onSettingChanged(
                data.selection[0].id !== this.props.timezone,
                data.selection && data.selection[0] && data.selection[0].id
              );
            }
          }}
          variant="readonly"
        />
      </div>
    );
  }
}

Timezone.propTypes = {
  timezone: PropTypes.string,
  tempTimezone: PropTypes.string,
  onSettingChanged: PropTypes.func.isRequired,
  timezoneChanged: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(Timezone);
